export default __webpack_public_path__ + "static/InterDisplay-BlackItalic-55a64c976dcf02b9e0a24396a37c83d7.woff";